import { Customer } from '../../../store/Customer';
import { PageCard } from '../../Compounds/CardWithTitle';
import { LabelValueField } from '../../Compounds/DetailPanel/LabelValueField';

export interface AdminPanelParams {
  data: Customer;
}

export const AdminPanel = ({ data }: AdminPanelParams) => {
  return (
    <PageCard
      dataTestId="admin-panel"
      title="Meta">
      <div className="flex px-4 pt-4 w-full">
        <LabelValueField
          label="Salesforce ID"
          value={data.sf_id}
          field="sf_id"
        />
        <LabelValueField
          label="UPSTACK ID"
          value={data.id}
          field="id"
        />
      </div>
    </PageCard>
  );
};
